/* tslint:disable */
import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { DataService } from '../../services/data.service';
import { FormControl } from '@angular/forms';
// import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
// import { PopoverModule } from "ngx-smart-popover";
import { Machines } from './../../classes/machines';
import { Observable, Subject } from 'rxjs';
import { map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { NaviFreshMartService } from 'src/app/shared/services/navi-fresh-mart.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Stall } from '../../classes/stall';
import { AuthService } from '@auth0/auth0-angular';
import { callbackUri } from '../../../auth.config';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-cart-header',
  templateUrl: './cart-header.component.html',
  styleUrls: ['./cart-header.component.scss']


})
export class CartHeaderComponent implements OnInit {


  @Input() class: string = 'header-2';
  // @Input() themeLogo: string = 'assets/images/icon/nfm-genie-logo.png'; // Default Logo
  @Input() themeLogo: string = 'assets/images/cart-icon.png';
  @Input() themeIcon: string = 'favicon.ico'; // Default Icon for mobile view
  @Input() topbar: boolean = true; // Default True
  @Input() sticky: boolean = false; // Default false
  @Input() genieName: string;
  public stick: boolean = false;
  loadingAction: boolean = false;
  isHomePage: boolean = false;
  isLogin: boolean = false;
  isCart: boolean = false;
  isCheckout: boolean = false;
  user;
  // registerForm: FormGroup;
  // submitted = false;

  machinesData: Stall[] = [];
  filteredMachinesData: Stall[] = [];
  machineControl: FormControl = new FormControl('');
  searchControl: FormControl = new FormControl('');
  isCardVisible: boolean;
  cardTimeout;
  protected _onDestroy = new Subject<void>();
  loggeedUser$ = this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.user$));
  isAuthUser: boolean = false;
  accountId = "";
  constructor(private router: Router,
    private location: Location,
    private dataService: DataService,
    private genieService: NaviFreshMartService,
    private auth: AuthService) {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.auth.isAuthenticated$.subscribe((isAuth) => this.isAuthUser = isAuth);
  }

  // private formBuilder: FormBuilder
  // convenience getter for easy access to form fields
  // get f() { return this.registerForm.controls; }
  // onSubmit() {
  //     this.submitted = true;
  //     // stop here if form is invalid
  //     if (this.registerForm.invalid) {
  //         return;
  //     }

  //     }
  ngOnInit(): void {
    const userDetails = JSON.parse(localStorage.getItem('user'));

    this.accountId = userDetails.accountId;
    const vendorId = this.genieService.getConfig().vendorId;
    const user = localStorage.getItem('user');
    if (user) {
      this.user = JSON.parse(user);
    }
    this.loadingAction = false;

    if (this.router.url && this.router.url == '/home/vegetable') {
      this.isHomePage = true;
    } else if (this.router.url && this.router.url == '/shop/cart') {
      this.isCart = true;
    }
    if (this.router.url && this.router.url == '/shop/checkout') {
      this.isCheckout = true;
    }
    if (localStorage.getItem('user')) {
      this.isLogin = true;
    }
    this.genieService.getMachines(vendorId, this.accountId).subscribe((data) => {
      let stallData = data?.supplierList;
      this.machinesData = stallData;
      //  this.machinesData = stallData.filter((data)=>{
      //    return data?.type==='Genie'
      //  });
      this.filteredMachinesData = this.machinesData;
      //    if(this.filteredMachinesData?.length > 0){
      //      this.machineControl.setValue(this.filteredMachinesData[0].stallid);
      //     this.dataService.setMachineId(this.filteredMachinesData[0].stallid);
      // // this.router.navigateByUrl(`shop/machine-prod-items`, {skipLocationChange:true});
      //    }


    })
    this.searchControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterMachines();
      });

    this.loadingAction = true;
    // this.registerForm = this.formBuilder.group({
    //       email: ['', [Validators.required, Validators.email]],
    //       password: ['', [Validators.required, Validators.minLength(6)]]
    //   });
  }
  protected filterMachines() {
    if (!this.machinesData) {
      return;
    }
    // get the search keyword
    let search = this.searchControl.value;
    if (!search) {
      this.filteredMachinesData = this.machinesData.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    // filter the banks
    this.filteredMachinesData = this.machinesData.filter(
      (bank) =>
        bank.name.toLowerCase().indexOf(search.toString()) > -1
    );
  }
  showCard() {
    clearTimeout(this.cardTimeout);
    this.isCardVisible = true;
  }

  hideCard() {
    this.cardTimeout = setTimeout(() => {
      this.isCardVisible = false;
    }, 300)


  }

  toggleCard() {
    clearTimeout(this.cardTimeout);
    this.isCardVisible = !this.isCardVisible;
  }
  navigate(queryParam: string) {
    this.router.navigate(['/pages/useraccount'], { queryParams: { tab: `${queryParam}` }, skipLocationChange: true });
  }
  OnMachineSelect(event) {
    console.log("event", event.value);
    event.value;
    this.dataService.setMachineId(event.value);
    this.router.navigateByUrl(`shop/machine-prod-items`, { skipLocationChange: true });
  }

  back() {
    this.location.back(); // <-- go back to previous location on cancel
  }

  logout() {
    this.auth.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.auth
          .logout({
            returnTo: callbackUri,
            federated: true
          });
      }
      console.log("logout");
      localStorage.removeItem('user');
      localStorage.removeItem('isProxyUser');
      localStorage.clear();
      this.router.navigate(['']);

    })






  }
  // @HostListener Decorator
  OnIconClick() {
    this.router.navigate([''], { skipLocationChange: true });
  }

}

